/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import type { RichText } from './rich-text'

/* TypeScript */
export type RichTextApiProps = {
  technicalName?: Maybe<string>
  richText: RichText | Record<string, never>
}

/* Schemas */
export const RichTextApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  richText: LooseRichTextSchema,
})

/* Schemas validation */
type TestRichTextProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<RichTextApiProps>,
    z.infer<typeof RichTextApiPropsSchema>
  >
>
